export class PobierzSrodekModel {
    idProjektu: string;
    idSrodka: string;
}